export const expeditePacketsOrderDefault = '{\n' +
    '    "contractId": ""\n' +
    '    "programName": ""\n' +
    '    "billingDateInMin": \n' +
    '    "cutoffDateInMin": \n' +
    '    "recurring": \n' +
    '}';

export interface IExpeditePacketsOrderRequest {
    contractId: string
    programName: string
    billingDateInMin: number
    cutoffDateInMin: number
    recurring: boolean
}
